// useUpdateProperty.js - Updated with better logging
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { propertyServices } from '../services/property.service';

export const useUpdateProperty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ propertyId, data }) => {
      // console.log('useUpdateProperty - Sending data:', JSON.stringify(data, null, 2));
      return propertyServices.updateProperty({
        propertyId,
        data,
      });
    },

    onSuccess: (_data, variables) => {
      // console.log('Update successful:', _data);
      queryClient.invalidateQueries({
        queryKey: ['properties'],
      });

      queryClient.invalidateQueries({
        queryKey: ['property', variables.propertyId],
      });
    },

    onError: (error) => {
      console.error('Failed to update property:', error);
      console.error('Error response:', error.response?.data);
    },
  });
};